(function(){
    'use strict';

    const members = document.querySelectorAll('.tut2021jury__member');

    members.forEach((member) => {
        const more = member.querySelector('.tut2021jury__more');

        if (!more) {
            return;
        }

        more.addEventListener('mouseover', () => {
            member.classList.add('show-text');
        });

        member.addEventListener('mouseout', (event) => {
            const target = event.toElement || event.relatedTarget; 

            if (member.contains(target)) {
                return;
            }

            member.classList.remove('show-text');
        });

        more.addEventListener('touchstart', () => {
            if (member.classList.contains('show-text')) {
                member.classList.remove('show-text');
            } else {
                members.forEach((member) => {
                    member.classList.remove('show-text');
                });

                member.classList.add('show-text');
            }
        });
    });

    const categoryfilter = document.querySelector('.tut2021categoryfilter');

    if (categoryfilter) {
        const agefilter = categoryfilter.querySelector('.news_category_147 ul');

        if (agefilter) {
            // Close age filter when clicking somewhere else
            document.addEventListener('click', (e) => {
                if (!agefilter.contains(e.target) && agefilter.classList.contains('show')) {
                    agefilter.classList.remove('show');
                }
            })

            // Close age filter when choosing an age
            agefilter.querySelectorAll('a').forEach((link) => {
                link.addEventListener('click', (e) => {
                    if (agefilter.classList.contains('show')) {
                        e.stopPropagation();
                        agefilter.classList.remove('show');
                    }

                    return true;
                });
            });

            // Open age filter when clicking on it
            agefilter.addEventListener('click', (e) => {
                if (!agefilter.classList.contains('show')) {
                    agefilter.classList.add('show');

                    if (agefilter.querySelector('.active')) {
                        agefilter.classList.add('has-active');
                    } else {
                        agefilter.classList.remove('has-active');
                    }

                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            }, true);
        }

        // AJAX load
        if (document.querySelector('.tut2021speakerlist')) {
            // Get all links
            const links = categoryfilter.querySelectorAll('a');

            // Iterate through all links
            links.forEach((link) => {
                // Add click event listener to all links
                link.addEventListener('click', (event) => {
                    event.preventDefault();

                    // Get the speaker list
                    const speakerlist = document.querySelector('.tut2021speakerlist');

                    // Add loading class
                    speakerlist.classList.add('loading');

                    // Get ajax_reload_element parameter
                    const are = speakerlist.dataset.ajaxReloadElement;

                    // Create and send AJAX request
                    const xhr = new XMLHttpRequest();
                    xhr.open('POST', link.href);
                    xhr.responseType = 'json';
                    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr.onload = function() {
                        if (xhr.status !== 200 || typeof xhr.response.status === 'undefined' || 'ok' !== xhr.response.status) {
                            return;
                        }

                        speakerlist.outerHTML = xhr.response.html;
                    };
                    xhr.onerror = function() {};
                    xhr.onloadend = function() {
                        speakerlist.classList.remove('loading');
                    };
                    xhr.send('ajax_reload_element='+are);

                    // Set active state
                    links.forEach((siblingLink) => {
                        siblingLink.classList.remove('active');
                        siblingLink.parentNode.classList.remove('active');
                    });

                    link.classList.add('active');
                    link.parentNode.classList.add('active');
                    agefilter.classList.remove('show');

                    return false;
                });
            });
        }
    }
})();
